import { Box, TableCell, TableRow } from '@mui/material';

import CustomCheckbox from '@/components/Checkbox';
import type { SymbolKey } from '@/entities/symbol';
import type { FactsheetSymbol } from '@/features/Factsheet';
import useSelectionFunctions from '@/features/SymbolSelector/hooks/useSelectionFunctions';

const ItemsTableRow = ({ symbol, code }: { symbol: FactsheetSymbol; code: string }) => {
  const { isSymbolSelected, toggleSymbolInSelection } = useSelectionFunctions();
  const { timeRef, period, periodType, alias, timeRefDetail } = symbol;
  const selectedSymbol: SymbolKey = {
    Code: code,
    Period: period,
    PeriodType: periodType,
    TimeRef: timeRef
  };
  const itemKey = code + timeRef + period + periodType;

  return (
    <TableRow
      key={itemKey}
      sx={{
        '&:last-child td, &:last-child th': { pb: 1 },
        '&:first-of-type td, &:first-of-type th': { pt: 1 }
      }}
    >
      <TableCell
        sx={{
          p: 0,
          pl: 1,
          pr: 1,
          borderLeft: 'none'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <CustomCheckbox
            checked={isSymbolSelected(selectedSymbol)}
            onChange={() => {
              toggleSymbolInSelection(selectedSymbol);
            }}
          />
        </Box>
      </TableCell>
      <TableCell
        component='th'
        scope='row'
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        {code}
      </TableCell>
      <TableCell>{timeRef}</TableCell>
      <TableCell>{periodType}</TableCell>
      <TableCell>{period}</TableCell>
      <TableCell sx={{ width: '20%' }}>{alias}</TableCell>
      <TableCell sx={{ width: '20%' }}>{timeRefDetail}</TableCell>
    </TableRow>
  );
};
export default ItemsTableRow;
